import { AccessibilityConfig } from "../types";

/**
 * Default Accessibility Configurations
 */
export const accessibilityConfig: AccessibilityConfig = {
    // Accessibility Tab or Focus Tab Default Config
    focusTab: {
        borderColor: '-webkit-focus-ring-color',
        borderSize: 1,
        borderRadius: 5
    },
};